import { Button } from 'antd'
import { FC } from 'react'
import { RowNode } from '@/presentation/common/components/dataGrid/lib/api.types.ts'
import { useCrud } from '@/presentation/common/hooks/crud/useCrud.ts'
import { useMaintainerStore } from '@/presentation/common/store/zustand/maintainer.ts'
import { DeleteMachineryFormProps } from '@/presentation/machinery/forms/types.ts'
import { useDeleteMachinery } from '@/presentation/machinery/hooks/useDeleteMachinery.ts'
import { QueryMachineryForTableResult } from '@/presentation/machinery/hooks/useQueryMachineryForTable.ts'

export const DeleteMachineryForm: FC<DeleteMachineryFormProps> = ({ onCancel, onFinish }) => {
  const messageApiKey = 'DeleteMachineryForm-alert'
  const { submit, isSuccess, isLoading, isError, message } = useDeleteMachinery()
  useCrud({ messageApiKey, message, isSuccess, isLoading, isError })

  const selectionNodes = useMaintainerStore((state) => state.selectionV2)
  const ids = Object.values(selectionNodes).map((node: RowNode<QueryMachineryForTableResult['items'][0]>) => node.data?.id)

  const onConfirmDelete = async () => {
    if (isLoading) {
      return
    }

    await submit({ ids })
    onFinish?.call(this)
  }

  return (
    <>
      <p className="text-center mb-6">
                Está apunto de eliminar los maquinarias seleccionados ({ids.length}).<br/>
                ¿Desea continuar con esta operación?
      </p>
      <div className="flex justify-center gap-2.5 pb-2">
        <Button size="small" type="primary" onClick={onCancel}>Cancelar</Button>
        <Button size="small" type="primary" danger onClick={onConfirmDelete}
          disabled={isLoading}>Eliminar</Button>
      </div>
    </>
  )
}
